import '.a{display:flex;}.ssr-plugin'
import '.b{flex-direction:column;}.ssr-plugin'
import '.j{gap:1.5rem;}.ssr-plugin'
import '.h{display:grid;}.ssr-plugin'
import '.t{align-items:center;}.ssr-plugin'
import '.ax{justify-content:center;}.ssr-plugin'
import '.n{width:100%;}.ssr-plugin'
import '.f6{gap:0.75rem;}.ssr-plugin'
import '.as{padding:1rem;}.ssr-plugin'
import '.f7{background-color:var(--palette-blue-50);}.ssr-plugin'
import '.c1{border:none;}.ssr-plugin'
import '.f8{border-radius:1rem;}.ssr-plugin'
import '.a1{cursor:pointer;}.ssr-plugin'
import '.f9{transition:background-color 0.2s ease;}.ssr-plugin'
import '.fa{width:1rem;}.ssr-plugin'
import '.fb{height:1rem;}.ssr-plugin'
import '.a5{color:var(--brand-secondary);}.ssr-plugin'
import '.fc{font-size:1.15rem;}.ssr-plugin'
import '.a7{font-weight:400;}.ssr-plugin'
import { styled } from 'inlines'
import { useState } from 'react'
import useMediaQuery from '@app/util/useMediaQuery'
import { useTranslations } from '@i18n/useLanguage'
import { Modal } from './Modal'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faEnvelope, faLink } from '@fortawesome/pro-regular-svg-icons'
import {
  faXTwitter,
  faFacebook,
  faWhatsapp,
} from '@fortawesome/free-brands-svg-icons'
import { SocialMediaButton } from './SocialMediaButton'

export type SocialShareModalProps = {
  isOpen: boolean
  onClose: () => void
  url?: string
  title?: string
  renderContainer?: HTMLElement
}

export const SocialShareModal = ({
  isOpen,
  onClose,
  url: urlProp,
  title: titleProp,
  renderContainer,
}: SocialShareModalProps) => {
  const translations = useTranslations().app
  const isMobile = useMediaQuery()
  const [copySuccess, setCopySuccess] = useState(false)

  const url =
    urlProp ?? (typeof window !== 'undefined' ? window.location.href : '')
  const title =
    titleProp ?? (typeof document !== 'undefined' ? document.title : '')

  const handleClose = () => {
    setCopySuccess(false)
    onClose()
  }

  const handleCopyLink = () => {
    navigator.clipboard
      .writeText(url)
      .then(() => {
        setCopySuccess(true)
        setTimeout(() => setCopySuccess(false), 2000)
      })
      .catch((err) => {
        console.error('Failed to copy link:', err)
      })
  }

  return (
    <Modal
      isOpen={isOpen}
      title={translations.socialShareModal.title}
      onClose={handleClose}
      backLabel={translations.socialShareModal.close}
      renderContainer={renderContainer}
    >
      <div className="a b j"
        data-testid="social-share-modal"
      >
        <div className="h j"
          style={{
            gridTemplateColumns: isMobile ? 'repeat(2, 1fr)' : 'repeat(4, 1fr)',}}
        >
          <SocialMediaButton
            icon={faEnvelope}
            label={translations.share.email}
            to={`mailto:?subject=${encodeURIComponent(`Check out: ${title}`)}&body=${encodeURIComponent(`I thought you might be interested in this: ${url}`)}`}
            isMobile={isMobile}
          />
          <SocialMediaButton
            icon={faXTwitter}
            label={translations.share.x}
            to={`https://twitter.com/intent/tweet?text=${encodeURIComponent(`Check out: ${title}`)}&url=${encodeURIComponent(url)}`}
            isMobile={isMobile}
          />
          <SocialMediaButton
            icon={faFacebook}
            label={translations.share.facebook}
            to={`https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(url)}`}
            isMobile={isMobile}
          />
          <SocialMediaButton
            icon={faWhatsapp}
            label={translations.share.whatsapp}
            to={`https://wa.me/?text=${encodeURIComponent(`Check out: ${title} - ${url}`)}`}
            isMobile={isMobile}
          />
        </div>

        <styled.button className="a t ax n f6 as f7 c1 f8 a1 f9"
          onClick={handleCopyLink}
          style={{
            '&:hover': {
              backgroundColor: 'var(--palette-blue-100)',
            },
          }}
        >
          <div className="fa fb a t ax a5"
          >
            <FontAwesomeIcon icon={faLink} />
          </div>
          <span className="fc a5 a7"
          >
            {copySuccess
              ? translations.share.copiedLink
              : translations.share.copyLink}
          </span>
        </styled.button>
      </div>
    </Modal>
  )
}
